"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubFeatureServiceV1 = exports.Subject = void 0;
class Subject {
    constructor() {
        this.callbacks = new Set();
        this.awaitResolvers = new Map();
    }
    get empty() {
        return !this.callbacks.size;
    }
    publish(data) {
        this.callbacks.forEach((callback) => {
            if (!(callback instanceof Function))
                return;
            callback(data);
        });
    }
    subscribe(callback) {
        this.callbacks.add(callback);
        this.awaitResolvers.forEach((resolver) => resolver());
        this.awaitResolvers.clear();
        return () => this.callbacks.delete(callback);
    }
    awaitSubscription(waiterId) {
        if (this.callbacks.size) {
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            this.awaitResolvers.set(waiterId, resolve);
        });
    }
}
exports.Subject = Subject;
class PubSubFeatureServiceV1 {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subjects = new Map();
    }
    getSubject(subjectId) {
        if (!this.subjects.has(subjectId)) {
            this.subjects.set(subjectId, new Subject());
        }
        return this.subjects.get(subjectId);
    }
    publish(subjectId, data) {
        if (!this.subjects.has(subjectId)) {
            const subjectIdString = typeof subjectId === 'symbol' ? subjectId.description : subjectId;
            console.warn(`pubsub-service: no subscription for subject "${subjectIdString}" present, published data won't be consumed by anyone`);
            return false;
        }
        const subject = this.getSubject(subjectId);
        subject.publish(data);
        return true;
    }
    subscribe(subjectId, callback) {
        const subject = this.getSubject(subjectId);
        const doRemove = subject.subscribe(callback);
        const remove = () => {
            doRemove();
            if (!subject.empty)
                return;
            this.subjects.delete(subjectId);
        };
        return {
            remove,
        };
    }
    awaitSubscription(waiterId, subjectId) {
        const subject = this.getSubject(subjectId);
        const publish = (data) => subject.publish(data);
        return subject.awaitSubscription(waiterId).then(() => ({
            publish,
        }));
    }
}
exports.PubSubFeatureServiceV1 = PubSubFeatureServiceV1;
//# sourceMappingURL=v1.js.map